import { Box, SxProps, Typography } from '@mui/material';
import { Item } from '@components/select';

export const Field = ({
  value,
  label,
  sxProps,
}: Item & {
  sxProps?: {
    box?: SxProps;
    value?: SxProps;
    label?: SxProps;
  };
}) => (
  <Box sx={sxProps?.box}>
    <Typography
      variant='bodySmall'
      sx={{
        color: 'text.subdued',
        display: 'inline',
        marginRight: '8px',
        ...sxProps?.value,
      }}
    >
      {value}
    </Typography>
    <Typography
      variant='bodySmall'
      sx={{
        fontWeight: 'bold',
        display: 'inline',
        ...sxProps?.label,
      }}
    >
      {label}
    </Typography>
  </Box>
);
